import { combineReducers } from 'redux';

import settings from './settings';
import BLSData from './BLSData';

export default combineReducers({
  settings,
  BLSData,
});
